import { render } from "./ChevronRight.vue?vue&type=template&id=bc6648c6"
import script from "./ChevronRight.vue?vue&type=script&lang=js"
export * from "./ChevronRight.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ChevronRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc6648c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc6648c6', __exports__)) {
    api.reload('bc6648c6', __exports__)
  }
  
  module.hot.accept("./ChevronRight.vue?vue&type=template&id=bc6648c6", () => {
    api.rerender('bc6648c6', render)
  })

}


export default __exports__